import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaInput {
  constructor() {
    this.name = '';
    this.placeholder = '';
    this.variant = 'static';
    this.inputId = undefined;
    this.minLength = undefined;
    this.maxLength = undefined;
    this.maxDate = undefined;
    this.minDate = undefined;
    this.disabled = undefined;
    this.readOnly = undefined;
    this.label = undefined;
    this.labelTransition = false;
    this.value = '';
    this.error = undefined;
    this.required = false;
    this.type = undefined;
    this.styles = undefined;
    this.classes = undefined;
    this.onChange = undefined;
    this.onKeyPress = undefined;
    this.onBlur = undefined;
    this.onInput = undefined;
    this.onClick = undefined;
    this.eyeIcon = false;
    this.reRender = false;
    this.onKeyUp = undefined;
  }
  handler(event) {
    this.error = (event === null || event === void 0 ? void 0 : event.detail) ? event === null || event === void 0 ? void 0 : event.detail : '';
    this.reRender = !this.reRender;
  }
  eyeClickHandler(e) {
    var _a;
    const target = (_a = e.target) === null || _a === void 0 ? void 0 : _a.previousSibling;
    if (target.getAttribute('type') === 'password') {
      target.setAttribute('type', 'text');
    }
    else {
      target.setAttribute('type', 'password');
    }
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), " ", this.label && !this.labelTransition && h("label", { innerHTML: this.label }), h("input", Object.assign({ class: this.getCssClassMap() }, this.getInputProps(), { onChange: this.onChange, onKeyPress: this.onKeyPress, onBlur: this.onBlur, onKeyUp: this.onKeyUp, onClick: this.onClick, onInput: this.onInput })), this.eyeIcon && h("span", { class: "eye-icon", onClick: this.eyeClickHandler.bind(this) }), this.label && this.labelTransition && h("label", { class: "input-label" }, this.label), this.error && h("span", { class: "input-error" }, this.error)));
  }
  getInputProps() {
    const props = {
      placeholder: this.placeholder || '',
      id: this.inputId || '',
      label: this.label || '',
      minlength: this.minLength || null,
      disabled: this.disabled || false,
      type: this.type || 'text',
      maxlength: this.maxLength || null,
      required: this.required || false,
      max: this.maxDate || null,
      min: this.minDate || null,
      name: this.name || '',
      value: this.value || '',
      readOnly: this.readOnly || false,
    };
    return Object.assign({}, props);
  }
  getCssClassMap() {
    return classNames('input', this.type && `input--type-${this.type}`, this.classes && `${this.classes}`);
  }
  static get is() { return "aiba-input"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-input.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-input.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false,
        "defaultValue": "''"
      },
      "placeholder": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "placeholder",
        "reflect": false,
        "defaultValue": "''"
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'animated' | 'static'",
          "resolved": "\"animated\" | \"static\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'static'"
      },
      "inputId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "input-id",
        "reflect": false
      },
      "minLength": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "min-length",
        "reflect": false
      },
      "maxLength": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "max-length",
        "reflect": false
      },
      "maxDate": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "max-date",
        "reflect": false
      },
      "minDate": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "min-date",
        "reflect": false
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disabled",
        "reflect": false
      },
      "readOnly": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-only",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false
      },
      "labelTransition": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label-transition",
        "reflect": false,
        "defaultValue": "false"
      },
      "value": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "value",
        "reflect": false,
        "defaultValue": "''"
      },
      "error": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error",
        "reflect": false
      },
      "required": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "required",
        "reflect": false,
        "defaultValue": "false"
      },
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'email' | 'hidden' | 'number' | 'password' | 'tel' | 'text' | 'textarea' | 'date'",
          "resolved": "\"date\" | \"email\" | \"hidden\" | \"number\" | \"password\" | \"tel\" | \"text\" | \"textarea\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "type",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "onChange": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-change",
        "reflect": false
      },
      "onKeyPress": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-key-press",
        "reflect": false
      },
      "onBlur": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-blur",
        "reflect": false
      },
      "onInput": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-input",
        "reflect": false
      },
      "onClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-click",
        "reflect": false
      },
      "eyeIcon": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "eye-icon",
        "reflect": false,
        "defaultValue": "false"
      },
      "onKeyUp": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-key-up",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "reRender": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-options-error-input",
        "method": "handler",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-input.js.map
